import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environmentConfig } from '../../config/config';

export const productsApi = createApi({
  reducerPath: 'productsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: environmentConfig.LAMBDA_URL.PRODUCTS,
    prepareHeaders: async (headers) => {
      headers.set('Content-Type', 'application/json');
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString() || session.tokens?.accessToken?.toString();
        if (token) {
          headers.set('Authorization', token);
        }
      } catch (e) {
        // No token available, skip setting header
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    createProduct: builder.mutation({
      query: (productData) => ({
        url: '/products',
        method: 'POST',
        body: productData,
      }),
    }),
    getProduct: builder.query({
      query: (productId) => `/products/${productId}`,
    }),
    updateProduct: builder.mutation({
      query: ({ productId, updateData }) => ({
        url: `/products/${productId}`,
        method: 'PUT',
        body: updateData,
      }),
    }),
    deleteProduct: builder.mutation({
      query: (productId) => ({
        url: `/products/${productId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

// Hooks for components
export const {
  useCreateProductMutation,
  useGetProductQuery,
  useLazyGetProductQuery,
  useUpdateProductMutation,
} = productsApi;
